/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  MutationKey,
  useMutation,
  UseMutationResult,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { userSessionIssuersCimdClientsDelete } from "../funcs/userSessionIssuersCimdClientsDelete.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { GramError } from "../models/errors/gramerror.js";
import {
  ConnectionError,
  InvalidRequestError,
  RequestAbortedError,
  RequestTimeoutError,
  UnexpectedClientError,
} from "../models/errors/httpclienterrors.js";
import { ResponseValidationError } from "../models/errors/responsevalidationerror.js";
import { SDKValidationError } from "../models/errors/sdkvalidationerror.js";
import { ServiceError } from "../models/errors/serviceerror.js";
import {
  DeleteUserSessionIssuerCimdClientRequest,
  DeleteUserSessionIssuerCimdClientSecurity,
} from "../models/operations/deleteusersessionissuercimdclient.js";
import { unwrapAsync } from "../types/fp.js";
import { useGramContext } from "./_context.js";
import { MutationHookOptions } from "./_types.js";

export type DeleteUserSessionIssuerCimdClientMutationVariables = {
  request: DeleteUserSessionIssuerCimdClientRequest;
  security?: DeleteUserSessionIssuerCimdClientSecurity | undefined;
  options?: RequestOptions;
};

export type DeleteUserSessionIssuerCimdClientMutationData = void;

export type DeleteUserSessionIssuerCimdClientMutationError =
  | ServiceError
  | GramError
  | ResponseValidationError
  | ConnectionError
  | RequestAbortedError
  | RequestTimeoutError
  | InvalidRequestError
  | UnexpectedClientError
  | SDKValidationError;

/**
 * deleteUserSessionIssuerCimdClient userSessionIssuersCimdClients
 *
 * @remarks
 * Remove a custom CIMD document URL from a user_session_issuer. New authorization requests from that client are denied immediately; sessions already issued to it are unaffected and continue until they expire.
 */
export function useDeleteUserSessionIssuerCimdClientMutation(
  options?: MutationHookOptions<
    DeleteUserSessionIssuerCimdClientMutationData,
    DeleteUserSessionIssuerCimdClientMutationError,
    DeleteUserSessionIssuerCimdClientMutationVariables
  >,
): UseMutationResult<
  DeleteUserSessionIssuerCimdClientMutationData,
  DeleteUserSessionIssuerCimdClientMutationError,
  DeleteUserSessionIssuerCimdClientMutationVariables
> {
  const client = useGramContext();
  return useMutation({
    ...buildDeleteUserSessionIssuerCimdClientMutation(client, options),
    ...options,
  });
}

export function mutationKeyDeleteUserSessionIssuerCimdClient(): MutationKey {
  return ["@gram/client", "userSessionIssuersCimdClients", "delete"];
}

export function buildDeleteUserSessionIssuerCimdClientMutation(
  client$: GramCore,
  hookOptions?: RequestOptions,
): {
  mutationKey: MutationKey;
  mutationFn: (
    variables: DeleteUserSessionIssuerCimdClientMutationVariables,
  ) => Promise<DeleteUserSessionIssuerCimdClientMutationData>;
} {
  return {
    mutationKey: mutationKeyDeleteUserSessionIssuerCimdClient(),
    mutationFn: function deleteUserSessionIssuerCimdClientMutationFn({
      request,
      security,
      options,
    }): Promise<DeleteUserSessionIssuerCimdClientMutationData> {
      const mergedOptions = {
        ...hookOptions,
        ...options,
        fetchOptions: {
          ...hookOptions?.fetchOptions,
          ...options?.fetchOptions,
          signal: combineSignals(
            hookOptions?.fetchOptions?.signal,
            options?.fetchOptions?.signal,
          ),
        },
      };
      return unwrapAsync(userSessionIssuersCimdClientsDelete(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}
